import { generateMeasuresFromDimensions } from './generate-measures.js';
import { meetingBodyLink } from './links.js';
import { seatTermStatusValueLabels, seatTypeValueLabels } from './value-labels.js';
const aggregatableDimensions = {
    'meeting_body_seat_terms.days_remaining': {
        aggregations: ['avg', 'min'],
        label: 'Days Remaining',
        type: 'number',
    },
    'meeting_body_seat_terms.status': {
        aggregations: ['countDistinct'],
        label: 'Status',
        type: 'string',
        valueLabels: seatTermStatusValueLabels,
    },
};
export const meetingBodySeatTermsCube = {
    category: 'Meeting Bodies',
    description: 'Seat terms with status, duration, vacancy dates, and linked campaigns.',
    label: 'Meeting Body Seat Terms',
    requiredModule: 'hasTenure',
    measures: {
        'meeting_body_seat_terms.count': { label: 'Count', type: 'number' },
        ...generateMeasuresFromDimensions(aggregatableDimensions),
    },
    dimensions: {
        ...aggregatableDimensions,
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
        'meeting_body_seat_terms.is_current': { label: 'Is Current', type: 'boolean' },
        'meeting_body_seats.number': { label: 'Seat Number', type: 'number' },
        'meeting_body_seats.title': { label: 'Seat Title', type: 'string' },
        'meeting_body_seats.type': {
            label: 'Seat Type',
            type: 'string',
            valueLabels: seatTypeValueLabels,
        },
        'seat_campaigns.name': { label: 'Seat Campaign', type: 'string' },
    },
    timeDimensions: {
        'meeting_body_seat_terms.created_at': { label: 'Created At', type: 'date' },
        'meeting_body_seat_terms.end_date': { label: 'End Date', type: 'date' },
        'meeting_body_seat_terms.start_date': { label: 'Start Date', type: 'date' },
        'meeting_body_seat_terms.updated_at': { label: 'Updated At', type: 'date' },
        'meeting_body_seat_terms.vacancy_date': { label: 'Vacancy Date', type: 'date' },
    },
};
